export enum ValvePolEnum {
  PRYAM,
  OBRAT,
}
